import React from "react";
import Icon from "../../libraries/icons";
import { useTranslation } from "react-i18next";
import config from '../../config';
import { history } from '../../routes';
import { getObjectWithJsonDataToFormValues, formatFullname } from '../../libraries/utils';


import Button from "../commons/Button";

export default function PatientHistoryElement({ appointment, actions, left, ...rest }) {
  const { t, i18n } = useTranslation();
  
  const { time, date, notes, prescriptions, professional } = getObjectWithJsonDataToFormValues(
    appointment, ['time', 'date', 'notes', 'prescriptions', 'professional']
  );
  const day = new Date(date)

  const  parsed_prescriptions = prescriptions ? JSON.parse(prescriptions) : []

  return (
    <div key={rest.key} className="text-left" >
      <div className="badge bg-opacity-10 text-gray-600 border-none mb-2">
        {time && <small className=""> {day.toLocaleDateString()} {time}</small>}
      </div>
      
      {<p className="my-3">{professional && formatFullname(professional)}</p>}
      {/*<p className="my-3">{notes}</p>*/}

      {parsed_prescriptions && parsed_prescriptions.map((prescription, index) => { 
        return (
          <div key={index} className="py-4 border-t">
            <h4 className="mb-1">{t("Diagnostico")}</h4>
            {prescription.json_data.diagnostics.map((diagnostic, index) =>{ 
                return (
                  <div key={index}>{diagnostic.name}</div>
                )
              })
            }
            <Button
              className="btn-primary btn-outline btn-sm mt-2"
              title={t("ver prescripción")}
              onClick={() => rest.onClick && rest.onClick(prescription) }
            />
          </div>
        )}
      )}  
    </div>
  );
}
